import { Nullable } from '@/shared/types/app.types'
import {
    IncidentTypeResponse
} from '@/modules/configurationModule/detail/incidents/incidents-types/services/incidents-types-laboratories.dto'
import { IncidentSeverityResponse } from '@/modules/configurationModule/detail/incidents/incidents-severities/services/incidents-severities.dto'
import { TranslationResponse } from '@/api/services/common.dto'

export interface ConfigurationIncidentsTypesLaboratoriesModalState {
    id: Nullable<number>,
    incidentType: Nullable<IncidentTypeResponse>,
    incidentSeverity: Nullable<IncidentSeverityResponse>,
    reportTitleTranslations: TranslationResponse[],
    reportFileName: string,
    active: boolean
}
export const initialConfigurationIncidentsTypesLaboratoriesModalState =
    (): ConfigurationIncidentsTypesLaboratoriesModalState => ({
        active: true,
        incidentSeverity: null,
        incidentType: null,
        reportFileName: '',
        reportTitleTranslations: [],
        id: null
    })
